import styled from '@emotion/styled'
import { css } from '@emotion/react'

export function CarouselStyles({ theme, carouselLayout, boxShadow }) {
  const layouts = {
    mobile: '90%',
    desktop3: '30%',
    desktop4: '23%',
  }

  const desktopLayout =
    carouselLayout === 'Yes, desktop (show 3 columns) and mobile'
      ? layouts.desktop3
      : layouts.desktop4

  return css`
    gap: 24px;
    margin: auto;
    display: flex;
    max-width: 100%;
    flex-direction: column;

    .embla__viewport {
      overflow: hidden;
    }

    .embla__container {
      gap: 16px;
      display: flex;
      touch-action: pan-y pinch-zoom;
    }

    .embla__slide {
      max-width: 100%;
      min-width: 250px;
      padding: ${boxShadow ? '18px 0' : '0'};
      flex: 0 0 ${desktopLayout};
    }

    .embla__slide__number {
      height: 100% !important;
      display: flex;
      user-select: none;
    }

    .embla__controls {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .embla__buttons {
      gap: 16px;
      display: grid;
      align-items: center;
      grid-template-columns: repeat(2, 1fr);
    }

    .embla__button {
      border: 0;
      margin: 0;
      padding: 0;
      z-index: 1;
      width: 32px;
      height: 32px;
      display: flex;
      color: #212721;
      cursor: pointer;
      appearance: none;
      border-radius: 50%;
      align-items: center;
      text-decoration: none;
      justify-content: center;
      -webkit-appearance: none;
      touch-action: manipulation;
      background-color: transparent;
      box-shadow: inset 0 0 0 1px #212721;
      -webkit-tap-highlight-color: #212721;
    }

    .embla__button:disabled {
      color: #d1d1d1;
      box-shadow: inset 0 0 0 1px #d1d1d1;
    }

    .embla__button__svg {
      width: 50%;
      height: 50%;
    }

    .embla__dots {
      gap: 8px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-end;
    }

    .embla__dot {
      margin: 0;
      border: 0;
      padding: 0;
      width: 16px;
      height: 16px;
      display: flex;
      cursor: pointer;
      appearance: none;
      border-radius: 50%;
      align-items: center;
      text-decoration: none;
      justify-content: center;
      -webkit-appearance: none;
      touch-action: manipulation;
      background-color: transparent;
      -webkit-tap-highlight-color: #d1d1d1;
    }

    .embla__dot:after {
      content: '';
      width: 16px;
      height: 16px;
      display: flex;
      border-radius: 50%;
      align-items: center;
      box-shadow: inset 0 0 0 1px #d1d1d1;
    }

    .embla__dot--selected:after {
      box-shadow: inset 0 0 0 1px #212721;
    }

    .leshen-column-wrapper {
      margin-left: 0;
      margin-right: 0;
    }

    @media (max-width: ${theme.breakpoints.md}) {
      .embla__slide {
        flex: 0 0 45%;
      }
    }

    @media (max-width: ${theme.breakpoints.sm}) {
      .embla__slide {
        flex: 0 0 80%;
      }
    }

    .leshen-package-card,
    .leshen-column-wrapper {
      width: 100% !important;
      height: 100% !important;

      .wrapper {
        height: 100% !important;
      }
    }

    .leshen-column-wrapper {
      margin-bottom: 0;

      .gatsby-image-wrapper {
        overflow: visible !important;
      }
    }

    .leshen-package-card {
      padding-left: 7px;
      padding-right: 7px;

      &:has(.package-label) {
        padding-top: 30px !important; // need this to give a little more space above the card for the label to show. This my lead to issues if the label's height is more than 30px
      }
    }
  `
}

export const Container = styled.div(CarouselStyles)
